






































































































































import Vue from "vue";
import Component from "vue-class-component";
import { Getter, Action } from "vuex-class";
import { Watch, Prop } from "vue-property-decorator";

import Schedule from "@/types/app/schedules";

import moment from "moment";

const namespace = "customer";

const NEXT_SCHEDULES = 1;
const PREVIOUS_SCHEDULES = 2;

@Component({})
export default class ModalSchedule extends Vue {
  @Getter("getModalScheduleState", { namespace })
  modalSchedule!: boolean;
  @Action("setModalScheduleState", { namespace })
  setModalScheduleState!: any;

  @Getter("getScheduleState", { namespace })
  schedule!: Schedule;

  @Action("setScheduleFeedbackModalState", { namespace })
  setScheduleFeedbackModalState!: any;

  @Prop(Number) public filterActive!: number;
  @Prop(Boolean) public loadingApprove!: boolean;
  @Prop(Boolean) public loadingReject!: boolean;

  @Watch("loadingApprove")
  handleCloseModalWhenApprove() {
    if (this.loadingApprove === false) this.closeModal();
  }

  @Watch("loadingReject")
  handleCloseModalWhenReject() {
    if (this.loadingReject === false) this.closeModal();
  }

  get schedulerName() {
    return `${this.schedule.firstName} ${this.schedule.lastName}`;
  }

  get alreadyBeenInformed() : boolean{
    return this.schedule.status == 'Done' || this.schedule.status == 'Reject';
  }

  public scheduleDate(item: string) {
    return `Meet: ${moment(item).format("DD MMM")} | ${moment(item).format(
      "HH:mm A"
    )}`;
  }

  public approveSchedule() {
    const params = {
      userId: this.schedule.userId,
      scheduleId: this.schedule.scheduleId,
      isApproved: true,
    };
    this.$emit("approveSchedule", params);
  }

  public rejectSchedule() {
    const params = {
      userId: this.schedule.userId,
      scheduleId: this.schedule.scheduleId,
      isApproved: false,
    };
    this.$emit("rejectSchedule", params);
  }

  public closeModal(): void {
    this.setModalScheduleState(false);
  }


}
